import { useEffect,useState } from 'react';

import useIsFirstRender from '@/hooks/useIsFirstRender';
import useTranslations from '@/i18n/useTranslations';
import InfoIconArtwork from '@/shared-components/icons/components/public/InfoIconArtwork';

import AudioLoading from './components/AudioLoading';
import AudioPlayer from './components/AudioPlayer';
import UploadAudio from './components/UploadAudio';

export default function Audio({ formError, setFormError, previewMode, fillWith, onChange, disabled = false, }) {
  const t = useTranslations('common.forms.add_artwork');
  const [audioFile, setAudioFile] = useState(fillWith);
  const [isInfoIconOpen, setIsInfoIconOpen] = useState(false);
  const isFirstRender = useIsFirstRender();

  useEffect(()=>{
    if(!isFirstRender) {
      if(!audioFile?.loading) {
        onChange(audioFile);
      } else {
        onChange(null);
      }
    }
  }, [audioFile]);

  return (
    <>
      {(!previewMode || audioFile) && (
        <h2 className="add-artwork-media-form__heading">
          {t('audio_title')}
          <InfoIconArtwork
            className="step-accordeon-step-header__info-icon"
            onClick={() => setIsInfoIconOpen((current) => !current)}
            open={isInfoIconOpen}
            header={t('audio_title')}
            description={t('audio_info')}
          />
        </h2>
      )}
      {
        audioFile?.loading ?
          <AudioLoading audioFile={audioFile} setAudioFile={setAudioFile}/>
          : audioFile?.audio_id ?
            <AudioPlayer 
              audioId={audioFile?.audio_id} 
              deleteAudio={()=>setAudioFile(null)} 
              previewMode={previewMode}
              disabled={disabled}
            />
            : 
            !previewMode && (
              <UploadAudio
                formError={formError}
                setFormError={setFormError}
                setAudioFile={setAudioFile}
                disabled={disabled}
              />
            )
      }
    </>
  );
}
